import { useState } from "react";
import { TitleSection } from "../title-section";
import BarChart from "./bar-chart";
import { QuizModal } from "../modal";
import { Button } from "../button";

interface QuestionProps {
  question: string;
  color: string;
}

// const questions: QuestionProps[] = [
//   {
//     question:
//       "Questão 01. A questão mais difícil de Ciências Humanas até 2023 envolvia um tema complexo de História, desafiando os candidatos com uma abordagem detalhada e interdisciplinar.",
//     color: "text-blue-500",
//   },
//   {
//     question:
//       "Questão 02. A questão aborda os impactos da universalização no século XX, relacionando o desenvolvimento dos transportes e da aviação civil à globalização.",
//     color: "text-blue-500",
//   },
//   {
//     question:
//       "Questão 03. A questão trata das transformações no trabalho durante a Revolução Industrial, com foco na mecanização da tecelagem e seus impactos sociais.",
//     color: "text-blue-500",
//   },
//   {
//     question:
//       "Questão 04. A questão aborda a Inquisição no Brasil colonial, destacando a perseguição a práticas consideradas heréticas pela Igreja Católica.",
//     color: "text-blue-500",
//   },
//   {
//     question:
//       "Questão 05. A questão trata da transição da tradição jurídica oral para a legislação escrita na Roma Antiga, destacando a importância da Lei das Doze Tábuas (451 a.C.).",
//     color: "text-blue-500",
//   },
//   {
//     question:
//       "Questão 06. A questão aborda a concepção de moralidade defendida por Jeremy Bentham, enfatizando uma visão utilitarista. Em vez de associar a moral a mandamentos divinos ou a princípios abstratos, Bentham propõe que ela se baseia nas consequências das ações, especialmente na promoção da felicidade coletiva.",
//     color: "text-blue-500",
//   },
//   {
//     question:
//       "Questão 07. A questão trata da visão de Santo Agostinho sobre a eternidade de Deus, criticando quem tenta aplicar noções humanas de tempo à existência divina. Para ele, Deus é eterno e imutável, fora do tempo.",
//     color: "text-blue-500",
//   },
//   {
//     question:
//       "Questão 08. A questão propõe uma reflexão sobre a possibilidade de o mundo ser apenas uma criação da mente, como um sonho do qual nunca se acorda.",
//     color: "text-blue-500",
//   },
//   {
//     question:
//       "Questão 09. O texto trata da criação dos museus na América Latina como instituições baseadas em modelos europeus, ligados à elite, e da necessidade de torná-los mais acessíveis ao público em geral.",
//     color: "text-blue-500",
//   },
//   {
//     question:
//       "Questão 10. Francisco de Assis tornou a religião mais próxima do povo ao usar a língua popular em vez do latim, aproximando a cultura religiosa da cultura popular.",
//     color: "text-blue-500",
//   },
// ];

export const MicroData = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section id="microdata" className="py-10 px-4 lg:px-0 flex justify-center">
      <div className="w-full lg:max-w-screen-md xl:max-w-screen-xl 2xl:max-w-screen-2xl">
        <TitleSection
          blueToRed={false}
          first_title="Análises"
          second_tilte="de Microdados"
          description="A dificuldade das questões de Ciências Humanas no ENEM segue um padrão que se repete ao longo dos anos. Isso se deve aos temas recorrentes, como História, Geografia, Sociologia e Filosofia, que exigem diferentes níveis de interpretação. As questões mais fáceis costumam abordar conteúdos mais diretos e familiares, enquanto as mais difíceis desafiam os candidatos com análises mais complexas e críticas. Atualmente, o sistema de avaliação de dificuldade do ENEM varia de 0 a 100, com o nível mais baixo representando a menor complexidade."
        />

        <div className="space-y-6">
          <div className="text-center">
            <div className="flex flex-col md:flex-row items-center justify-between w-full space-y-6 md:space-y-0">
              <div className="md:w-1/2">
                <div className="flex flex-col space-y-3">
                  <h2 className="text-primary font-semibold">
                    Responda a um quiz com algumas das questões mais
                    desafiadoras do Enem na área de Ciências Humanas:
                  </h2>
                </div>
                <Button
                  className="text-sm lg:text-base mt-6 px-6 py-3 bg-white text-primary font-medium rounded-lg shadow-md hover:bg-gray-100"
                  onClick={() => setIsModalOpen(true)}
                >
                  Responder Quiz
                </Button>
              </div>
              <BarChart />
            </div>
          </div>

          {isModalOpen && (
            <QuizModal
              isOpen={!!isModalOpen}
              setIsOpen={() => setIsModalOpen(false)}
              // question={isModalOpen.question}
              // alternatives={selectedQuestion.alternatives}
            />
          )}
        </div>
      </div>
    </section>
  );
};
